"use client";

import { useState } from "react";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import { Lightbox } from "./Lightbox";
import { NDIAMSYL } from "@/lib/diwline-data";

export function Ndiamsyl() {
  const [idx, setIdx] = useState<number | null>(null);
  const oeuvre = idx === null ? null : NDIAMSYL[idx];
  const nav = (d: number) =>
    setIdx(cur => (cur === null ? null : (cur + d + NDIAMSYL.length) % NDIAMSYL.length));

  return (
    <section
      id="ndiamsyl"
      className="relative bg-gradient-to-b from-bordeaux-deep via-bordeaux/25 to-royal py-24 md:py-32"
      aria-label="Le Patrimoine Royal NDIAMSYL"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          numero="VIII"
          titre="Le Patrimoine Royal NDIAMSYL"
          intro="Découvrez la collection patrimoniale NDIAMSYL — 42 images illustrant la richesse du Sénégal à travers son agriculture, ses portraits royaux, son éducation, sa jeunesse entrepreneuriat, sa santé, sa recherche et ses traditions. Un hommage vibrant à la nation sénégalaise sous l'égide de Sa Majesté."
        />

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {NDIAMSYL.map((o, i) => (
            <Reveal key={o.src + i} delay={(i % 4) * 0.06}>
              <button
                type="button"
                onClick={() => setIdx(i)}
                className="group relative block w-full overflow-hidden rounded-sm border border-gold/20 focus-visible:outline-gold"
                aria-label={`Agrandir : ${o.titre}`}
              >
                <img
                  src={o.src}
                  alt={o.titre}
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-107"
                />
                <span className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/20 opacity-70 transition-opacity group-hover:opacity-100" />
                <span className="absolute top-3 left-3 rounded-sm bg-black/55 px-2.5 py-1 font-display text-[11px] tracking-[0.2em] text-gold backdrop-blur-sm">
                  NDI-{String(i + 1).padStart(2, "0")}
                </span>
                <span className="absolute bottom-3 left-3 right-3 translate-y-2 text-left text-[11.5px] font-medium leading-snug text-gold-light opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                  {o.titre}
                </span>
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10">
          <div className="mx-auto flex max-w-3xl flex-col items-center gap-4 rounded-sm border border-gold/25 bg-royal/60 p-8 text-center">
            <p className="font-elegant text-lg italic text-gold-light">
              « NDIAMSYL — la mémoire vivante du Sénégal, conservée comme un trésor de cour. »
            </p>
            <p className="text-xs uppercase tracking-[0.3em] text-cream/50">
              42 planches · Agriculture · Portraits · Éducation · Santé · Recherche · Traditions
            </p>
          </div>
        </Reveal>
      </div>

      <Lightbox oeuvre={oeuvre} onClose={() => setIdx(null)} onPrev={() => nav(-1)} onNext={() => nav(1)} />
    </section>
  );
}
